/* FELRIO — Watch & Shop (Instagram-style reels) */
(function () {
  'use strict';

  var userSoundOn = false;

  function init(section) {
    if (section.dataset.felrioWsInit === '1') return;
    section.dataset.felrioWsInit = '1';

    var track = section.querySelector('[data-ws-track]');
    var reels = section.querySelectorAll('.felrio-ws__reel');
    if (!reels.length) return;

    var videos = [];
    var soundHint = section.querySelector('[data-sound-hint]');

    reels.forEach(function (reel) {
      var video = reel.querySelector('video.felrio-ws__video');
      if (!video) return;
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('x5-playsinline', '');
      videos.push(video);
    });

    function syncMuteIcon(video) {
      var reel = video.closest('.felrio-ws__reel');
      if (!reel) return;
      var mutedIcon = reel.querySelector('[data-icon="muted"]');
      var unmutedIcon = reel.querySelector('[data-icon="unmuted"]');
      if (!mutedIcon || !unmutedIcon) return;
      mutedIcon.hidden = !video.muted;
      unmutedIcon.hidden = video.muted;
    }
    function syncAllMuteIcons() { videos.forEach(syncMuteIcon); }

    function hideSoundHint() {
      if (soundHint && !soundHint.classList.contains('is-hidden')) {
        soundHint.classList.add('is-hidden');
        setTimeout(function () {
          if (soundHint && soundHint.parentNode) soundHint.parentNode.removeChild(soundHint);
        }, 400);
      }
    }

    function toggleSound() {
      userSoundOn = !userSoundOn;
      hideSoundHint();
      videos.forEach(function (v) {
        v.muted = !userSoundOn;
        if (!v.paused && userSoundOn) v.play().catch(function () {});
      });
      syncAllMuteIcons();
    }

    reels.forEach(function (reel) {
      var muteBtn = reel.querySelector('[data-mute-btn]');
      if (muteBtn) {
        muteBtn.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation(); toggleSound();
        });
      }
      var videoTap = reel.querySelector('[data-tap-video]');
      if (videoTap) {
        videoTap.addEventListener('click', function (e) {
          if (e.target.closest('.felrio-ws__product')) return;
          e.preventDefault(); toggleSound();
        });
      }
    });

    var currentVideo = null;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var v = entry.target;
            if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
              v.muted = !userSoundOn;
              currentVideo = v;
              v.play().catch(function () {
                if (!v.muted) { v.muted = true; v.play().catch(function () {}); }
              });
              syncMuteIcon(v);
            } else {
              try { v.pause(); } catch (e) {}
              v.muted = true;
              syncMuteIcon(v);
            }
          });
        },
        { root: track || null, threshold: [0, 0.6, 0.95] }
      );
      videos.forEach(function (v) { io.observe(v); });
    } else if (videos[0]) {
      videos[0].play().catch(function () {});
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        videos.forEach(function (v) { try { v.pause(); } catch (e) {} });
      } else if (currentVideo) {
        currentVideo.play().catch(function () {});
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-felrio-ws]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-felrio-ws]');
    if (section) init(section);
  });
})();